import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

export default function GetFilesInFolder({
    action,
    variables,
    setOpenVariable,
    automId
}) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.FOLDER.GET-FILES-IN-FOLDER.";
    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "FOLDER-PATH")} is_required />
                <TextInput
                    action={action}
                    inputName="folderPath"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                    // extractPath="folder"
                    fieldType="string"
                    displayName={t(label + 'FOLDER-PATH')}
                    hideRequired
                    autom_id={automId}
                />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN-VALUE')} is_required />
                <VariablePicker action={action} inputName="set" variables={variables} isRequired hideRequired setOpenVariable={setOpenVariable} filter="array" />
                <small
                    className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
            </div>
        </div>
    );
}
